import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { EMPTY_DATA_SEARCH_REFERENCE_TEMPLATE_CONTRACT } from './constant/emptyData';
import uploadFileApi from 'api/uploadFileApi';
import referenceContractApi from 'api/reference-template/referenceContractApi';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_REFERENCE_TEMPLATE_CONTRACT
    }
};

export const uploadTemplateThunk = createAsyncThunk(
    'referenceTemplateContractNew/uploadTemplate',
    async (payload, { rejectWithValue }) => {
        try {
            const { formData, typeGet, uuid, isMock, fileUrl, fileName, title, description, contract_type_uuid, file_thumbnail } = payload;

            let uploadedFileUrl = fileUrl;
            let uploadedFileName = fileName;

            // If not a mock file, upload it locally first
            if (!isMock) {
                const uploadRes = await uploadFileApi.uploadLocalConvert(formData);
                if (uploadRes.status === 1) {
                    uploadedFileUrl = uploadRes.file;
                    uploadedFileName = uploadRes.name;
                } else {
                    return rejectWithValue({
                        status: uploadRes?.status,
                        message: uploadRes?.message || 'Lỗi khi tải file',
                        errors: uploadRes?.error || uploadRes?.errors || { file: uploadRes?.message || 'Lỗi khi tải file' },
                    });
                }
            }

            // Call the reference contract upload API
            const createRes = await referenceContractApi.upload({
                file: uploadedFileUrl,
                file_name: uploadedFileName,
                typeGet: typeGet,
                uuid: uuid || '',
                title: title,
                description: description,
                contract_type_uuid: contract_type_uuid,
                file_thumbnail: file_thumbnail || '', // base64 thumbnail trang đầu PDF
            });

            if (createRes.status === 1 && createRes.data) {
                return createRes; // { uuid, status, current_step, ... }
            }
            return rejectWithValue({
                status: createRes?.status,
                message: createRes?.message || 'Lỗi khi tạo mẫu hợp đồng',
                errors: createRes?.error || createRes?.errors || {},
            });
        } catch (error) {
            const responseData = error.response?.data;
            return rejectWithValue({
                status: responseData?.status || error.response?.status,
                message: responseData?.message || error?.message || 'Lỗi hệ thống',
                errors: responseData?.error || responseData?.errors || {},
            });
        }
    }
);

export const referenceTemplateContractNewSlice = createSlice({
    name: 'referenceTemplateContractNew',
    initialState,
    reducers: {
        searchReferenceTemplateContractNew: (state, action) => {
            state.search = action.payload;
        },
        searchReferenceTemplateContractNewPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})

const { reducer, actions } = referenceTemplateContractNewSlice;
// Action creators are generated for each case reducer function
export const { searchReferenceTemplateContractNew, searchReferenceTemplateContractNewPageFirst } = actions

export const selectSearchReferenceTemplateContractNew = (state) => state?.features?.referenceTemplateContractNew?.search

export default reducer
